import React from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getTranslationsForLanguage } from "@/i18n";

export default function ReceiptDownloadButton({ transaction, userEmail, copy, locale = "en" }) {
  const labels = copy || getTranslationsForLanguage(locale, "billing").receipt;

  if (transaction?.status !== "succeeded") return null;

  const handleDownload = async () => {
    const { jsPDF } = await import("jspdf");
    const doc = new jsPDF();
    const date = transaction.created_date ? new Date(transaction.created_date).toLocaleDateString(locale) : new Date().toLocaleDateString(locale);
    const receiptId = transaction.provider_transaction_id || transaction.id || "receipt";

    doc.setFontSize(20);
    doc.text(labels.title, 20, 24);

    doc.setFontSize(11);
    doc.text("Marstick", 20, 34);
    doc.text(`${labels.receiptId}: ${receiptId}`, 20, 46);
    doc.text(`${labels.date}: ${date}`, 20, 56);
    doc.text(`${labels.member}: ${transaction.user_email || userEmail || labels.memberFallback}`, 20, 66);
    doc.text(`${labels.tier}: ${transaction.plan_tier || "N/A"}`, 20, 76);
    doc.text(`${labels.cycle}: ${transaction.billing_cycle || "N/A"}`, 20, 86);
    doc.text(`${labels.type}: ${(transaction.transaction_type || "payment").replace(/_/g, " ")}`, 20, 96);
    doc.text(`${labels.provider}: ${transaction.provider || "N/A"}`, 20, 106);
    doc.text(`${labels.status}: ${transaction.status}`, 20, 116);

    doc.setFontSize(16);
    doc.text(`${labels.total}: ${transaction.currency || "USD"} ${Number(transaction.amount || 0).toFixed(2)}`, 20, 134);

    doc.setFontSize(10);
    doc.text(labels.thanks, 20, 154);

    doc.save(`marstick-receipt-${receiptId}.pdf`);
  };

  return (
    <Button variant="ghost" size="sm" className="ml-2" onClick={handleDownload}>
      <Download className="w-4 h-4" />
      {labels.button}
    </Button>
  );
}